import { Avatar } from "@radix-ui/themes";
import FontAwesome from "../../utilities/FontAwesome";

export function ChatAvatar(props: {
  branding: {
    type: "image" | "fontawesome" | "text";
    alt?: string;
    value: string;
  };
  avatarProps?: any;
}) {
  const { avatarProps = {} } = props;

  if (props.branding.type === "image") {
    return (
      <Avatar
        src={props.branding.value}
        alt={props.branding.alt}
        radius={"full"}
        color={"gray"}
        fallback={""}
        {...avatarProps}
      />
    );
  } else if (props.branding.type === "fontawesome") {
    return (
      <Avatar
        fallback={<FontAwesome name={props.branding.value} />}
        radius={"full"}
        color={"gray"}
        {...avatarProps}
      />
    );
  } else if (props.branding.type === "text") {
    return (
      <Avatar
        fallback={props.branding.value}
        radius={"full"}
        color={"gray"}
        {...avatarProps}
      />
    );
  } else {
    return (
      <Avatar
        fallback={
          <FontAwesome name={"fa-user"} prefix={"fas"} {...avatarProps} />
        }
        radius={"full"}
        color={"gray"}
      />
    );
  }
}
